import axios from 'axios'
import store from '../store/index'
const API = axios.create()
//test
API.interceptors.request.use(function (config) {
  config.headers.Authorization = `Bearer ${localStorage.getItem('access_token')}` || ""
  return config;
})

API.interceptors.response.use(async function (response) {
  return response;
}, async function (error) {
    const {config, response: {status,data}} = error;
      if(status == 401){
        await getAccessToken();
        //window.location.href = `https://meetingservice.easy-web.cloud/#/dashboard`
      }
      if(status == 403){
        store.dispatch('auth/logout')
      }

});
async function getAccessToken(){
  API.post('/auth/token',{token: localStorage.getItem('refresh_token') || null})
  .then(response => {
    localStorage.setItem('access_token', response.data.access_token);
  })
}
export default API
